import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { JOURNEY_EXPERIENCE_TEAM } from '@leagueplatform/health-journey-common';
import { ErrorContext } from '@leagueplatform/observability';

export const GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE =
  'get_active_opt_in_campaign_limit_info';

export const getActiveCampaignLimitInfo = async (errorContext?: ErrorContext) =>
  SocketAsFetch.fetch(
    {
      message_type: GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE,
    },
    {
      errorContext: { ownershipTeam: JOURNEY_EXPERIENCE_TEAM, ...errorContext },
    },
  );
